const baseUrl = 'https://oilanalysisbackpro-api-dev.azurewebsites.net';

export const environment = {
  apiBaseUrl: baseUrl,
  production: false,
  getFilterOptions: baseUrl + '/GetFilterOptions',
  getAssetMeta: baseUrl + '/GetAssetMeta',
  getRecentSACount: baseUrl + '/GetRecentSACount',
  getBarChartData: baseUrl + '/GetBarChartData',
  uploadFile: baseUrl + '/UploadFile',
  getGaugeChartData: baseUrl + '/GetGaugeChartData',
  getReportList: baseUrl + '/GetReportList',
  getConsolidatedReport: baseUrl + '/getConsolidatedReport',
  getTerminalNames: baseUrl + '/GetTerminalMaster',
  GetTerminalsForLab: baseUrl + '/GetTerminalsForLab',
  getLabNames: baseUrl + '/GetLabs',
  getUploadFilesList: baseUrl + '/UploadFileList',
  downloadFile: baseUrl + '/DownloadFile',
  getFileErrors: baseUrl + '/GetFileErrors',
  retryFileProcessing: baseUrl + '/RetryFileProcessing',
  uploadOLCFile: baseUrl + '/UploadOLCFile',
  getOLCUploadStatus: baseUrl + '/GetOLCUploadStatus',
  getOLCUploadStatusById: baseUrl + '/GetOLCUploadStatusById',
  getOLCFileErrors: baseUrl + '/GetOLCFileErrors',
  downloadOLCFile: baseUrl + '/DownloadOLCFile',
  retryOLCFileProcessing: baseUrl + '/RetryOLCFileProcessing',
  ValidateUser: baseUrl + '/ValidateUser',
  ValidateToken: baseUrl + '/ValidateToken',
  msalConfig: {
    auth: {
      clientId: '7fe32bb8-55f3-497a-a875-4b754f98040f',
      tenantID: '05d75c05-fa1a-42e7-9cf1-eb416c396f2d',
      authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d'
    }
  },
  apiConfig: {
    uri: 'api://7fe32bb8-55f3-497a-a875-4b754f98040f/access'
  },
  rumConfig: {
    appName: 'OilAnalysis-dev',
    apiKey: '4fwiKavJmvHIxasF4zHnu1AUp96A0NR5Nj//dg+MBa+ZoBvf05GN1DM2xpToEA=='
  },
  fileUpload: {
    maxFileSizeMB: 10, // must not exceed what the backend/API actually accepts
    allowedExtensions: ['csv', 'xls', 'xlsx']
  },
  orbitAnalytics: {
    gtmId: 'GTM-M44QCF38',
    appName: 'OilAnalysis-dev',
    dataLayerName: 'dataLayer'
  }
};
